import { DASHBOARD_DATA_PENDING, DASHBOARD_DATA_SUCCESS, DASHBOARD_DATA_FAIL } from "../Actions/Types";

const initialState = {
    getDashboardData: [],
};
const dashboard_data_reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                getDashboardData: payload.getDashboardData,
            };
        case DASHBOARD_DATA_PENDING:
            return {
                ...state,
                getDashboardData: payload.getDashboardData,
            };
        case DASHBOARD_DATA_FAIL:
            return {
                ...state,
                getDashboardData: initialState.getDashboardData,
            };

        default:
            return state;
    }
};
export default dashboard_data_reducer;